'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*

  Declare and export all DOM strings here

  e.g.

  export default {
    inlineCart: '[data-inline-cart]',
    inlineCartContents: '[data-inline-cart-contents]',
  };

  Usage:

  import dom from 'common/Dom';
  import { getCartContents } from './handlers';

  $(dom.inlineCartContents).html(getCartContents());

*/

exports.default = {
  // Common Classes
  isActive: 'is-active',
  isValid: 'is-valid',
  isError: 'is-error',
  isSuccess: 'is-success',

  //Mobile Nav
  navTrigger: '[data-nav-trigger]',
  navCloseTrigger: '[data-nav-trigger-close]',
  nav: '[data-nav]',
  overlay: '[data-site-overlay]',
  siteContainer: '[data-site-container]',

  //Nav
  navDropdownTrigger: '[data-nav-dropdown-trigger]',
  navProductLink: '[data-product-link]',
  navDropdownColumn: '[data-nav-dropdown-column]',
  navDropdownImage: '[data-nav-dropdown-image]',

  //Sticky Header
  header: '[data-header]',
  headerMarker: '[data-header-marker]',

  //Scroll
  scrollElement: '[data-scroll]',

  //Inline Cart
  inlineCart: '[data-inline-cart]',
  inlineCartContent: '[data-inline-cart-contents]',
  inlineCartTrigger: '[data-inline-cart-trigger]',
  inlineCartCloseTrigger: '[data-inline-cart-close-trigger]',

  //Add Product
  addItem: '[data-add-cart]',
  addVariant: '[data-product-select]',

  //Subscription
  subscriptionTrigger: '[data-add-subscription]',
  subscriptionPrice: '[data-subscription-price]',
  subscriptionOptions: '[data-product-ro-options]',
  subscriptionClose: '[data-product-ro-cancel]',
  subscriptionContainer: '[data-product-ro-container]',
  subscriptionProductBar: '[data-product-bar-ro]',
  subscriptionFrequencyNum: '[data-product-bar-ro-frequency-num]',
  subscriptionFrequencyType: '[data-product-bar-ro-frequency-type]',

  //Cart
  cartItemCount: '[data-cart-item-count]',
  cartPage: '[data-cart]',
  cartPageContent: '[data-cart-contents]',
  lineItem: '[data-line-item]',
  lineItemRemoveTrigger: '[data-line-item-remove-trigger]',

  //QTY Selector
  qty: '[data-quantity]',
  qtyAdjust: '[data-quantity-adjust]',
  qtyInput: '[data-quantity-input]',

  // Sliders
  testimonialSlider: '[data-testimonial-slider]',
  instagramSlider: '[data-instagram-slider]',
  featuredProductSlider: '[data-featured-product-slider]',
  featuredArticleSlider: '[data-featured-article-slider]',
  featuredContentSlider: '[data-featured-content-slider]',
  productImageSlider: '[data-product-image-slider]',
  productBottleSlider: '[data-bottle-slider]',
  productContentSlider: '[data-product-content-slider]',
  qualityActiveIngredientSlider: '[data-active-ingredient-slider]',

  //Popups
  popupTrigger: '[data-popup-trigger]',
  popupCloseTrigger: '[data-popup-close-trigger]',
  popup: '[data-popup]',

  //Equal Height
  equalHeight: '[data-equal-height]',
  equalHeightGroup: '[data-equal-height-group]',

  //Splash
  splash: '[data-splash]',
  splashImage: '[data-splash-image]',
  splashContent: '[data-splash-content]',

  //Hero
  hero: '[data-hero]',
  heroBlock: '[data-hero-block]',
  heroImages: '[data-hero-images]',
  heroImageSecondary: '[data-image-secondary]',
  heroImageBg: '[data-image-bg]',

  //Image Parallax
  parallaxContainer: '[data-parallax-container]',
  parallaxImagePrimary: '[data-parallax-primary]',
  parallaxImageSecondary: '[data-parallax-secondary]',

  //Filters
  filter: '[data-filter]',
  filterTrigger: '[data-filter-trigger]',
  filterCurrent: '[data-filter-current]',
  filterDropdown: '[data-filter-dropdown]',
  filterCollection: '[data-filter-collection]',
  filterTag: '[data-filter-tag]',
  filterOption: '[data-filter-option]',

  //Producrt
  productPrice: '[data-product-price]',
  productOriginalPrice: '[data-product-original-price]',

  //Product Bar
  productDetails: '[data-product-details]',
  productBar: '[data-product-bar]',
  productBarTextChange: '[data-text-change]',

  //Product Tabbed Content
  productTabTrigger: '[data-tab-trigger]',
  productTabContent: '[data-tab-content]',
  productTab: '[data-tab]',

  //Product Swatches
  productSwatch: '[data-product-swatch]',

  //Secondary Nav Sticky
  secondaryNav: '[data-secondary-nav]',
  secondaryNavMarker: '[data-secondary-nav-marker]',
  waypointNav: '[data-waypoint-nav]',
  waypointBlock: '[data-waypoint-block]',

  //Quality Ingredients
  qualityInactiveIngredient: '[data-quality-inactive-ingredient]',

  //Batch
  qualityBatch: '[data-batch]',
  qualityForm: '[data-quality-form]',
  qualityInput: '[data-quality-input]',
  qualityMessage: '[data-quality-message]',

  //FAQ Toggle
  faqBlock: '[data-faq-block]',
  faqQuestionTrigger: '[data-faq-question-trigger]',
  faqQuestion: '[data-faq-question]',
  faqAnswer: '[data-faq-answer]',
  faqContainer: '[data-faq]',
  faqBackgroundFix: '[data-faq-background]',

  //Contact Form
  contactForm: '[data-contact-form]',
  contactFormTrigger: '[data-contact-trigger]',
  contactFormCancelTrigger: '[data-contact-cancel-trigger]',
  contactFormSubmit: '[data-contact-submit]',
  contactMessage: '[data-contact-message]',

  //Ingredient List
  ingredientContainer: '[data-ingredient-container]',
  ingredientList: '[data-ingredient-list]',
  ingredient: '[data-ingredient]',
  ingredientTrigger: '[data-ingredient-trigger]',
  ingredientCloseTrigger: '[data-ingredient-close-trigger]',
  ingredientDetails: '[data-ingredient-details]',
  ingredientCursor: '[data-ingredient-cursor]',

  //Login Forms
  loginForm: '[data-login]',
  recoverForm: '[data-recover-password]',
  recoverFormTrigger: '[data-recover-password-trigger]',
  resetSuccessMessage: '[data-reset-success]',
  resetSuccessTrigger: '[data-reset-success-trigger]',

  //Address Forms
  addressTrigger: '[data-address-trigger]',
  addressForm: '[data-address-form]',
  addressFormsContainer: '[data-address-forms]',
  addressCancelTrigger: '[data-address-cancel-trigger]',
  countrySelector: '[data-address-country]',
  provinceSelector: '[data-address-province]',
  deleteForm: '[data-address-delete-form]',
  addressDetails: '[data-address-details]'
};